<template>
  <Contact
    @getStoredData="handleGetStoredData"
    @submitAddress="handleSubmitAddress"
    :storedData="storedData"
    :isComplete="isComplete"
  />
</template>

<script>
import Contact from '@/components/templates/common/Contact';
import { mapActions, mapState } from 'vuex';
import store from '../contactStore';
import rootStore from '@/store';

export default {
  components: { Contact },
  computed: {
    ...mapState('app/contact', {
      storedData: state => state.userAddress,
      isComplete: state => state.submitUserAddressComplete
    })
  },
  beforeDestroy() {
    rootStore.unregisterModule(['app', 'contact'], store);
  },
  created() {
    rootStore.registerModule(['app', 'contact'], store);
  },
  methods: {
    ...mapActions('app/contact', {
      handleGetStoredData: 'getUserAddress',
      handleSubmitAddress: 'submitAddress'
    })
  }
};
</script>
